// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.no-pro-unlock-stats__container .modal__container {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: var(--space-and-half);
    max-width: 490px;
}

.modal.no-pro-unlock-stats__container .hubicon-award_star {
    font-size: 26px;
}


.no-pro-unlock-stat__title {
    color: var(--primary-very-dark-color);
    text-align: center;
    font-family: "Lexend Deca";
    font-size: 19px;
    font-weight: var(--font-medium);
    margin-top: 6px;
}

.no-pro-unlock-stat__message {
    color: var(--primary-very-dark-color);
    text-align: center;
    font-family: "Lexend Deca";
    font-size: 17px;
    font-weight: var(--font-regular);
    margin-top: 10px;
}

.no-pro-unlock-stats__advanteges {
    margin-top: 18px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.no-pro-unlock-stat__advantage {
    color: var(--primary-dark-color);
    text-align: left;
    font-family: "Lexend Deca";
    font-size: 16px;
    font-weight: var(--font-regular);
    padding: 5px 0;
}

.no-pro-unlock-stat__advantage .hubicon-check1 {
    font-size: 20px;
    padding: 8px;
}

.no-pro-unlock-stat__bottom-message {
    color: var(--basic-gray-color);
    text-align: center;
    font-family: "Lexend Deca";
    font-size: 14px;
    font-weight: var(--font-regular);
    margin-top: 12px;
}

.no-pro-unlock-stats__container .button {
    width: 100%;
    text-transform: unset;
}

.no-pro-unlock-stats__container .button span {
    text-transform: unset;
}

.no-pro-unlock-stats__container .button.primary-button {
    margin-top: 24px;
}

.no-pro-unlock-stats__container .button.text-button {
    margin-top: 10px;
    color: var(--primary-very-dark-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/no-pro-unlock-stats-modal/NoProUnlockStatsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,yDAAyD;AAC7D;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;AACzC","sourcesContent":[".modal.no-pro-unlock-stats__container .modal__container {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    padding: var(--space-and-half);\n    max-width: 490px;\n}\n\n.modal.no-pro-unlock-stats__container .hubicon-award_star {\n    font-size: 26px;\n}\n\n\n.no-pro-unlock-stat__title {\n    color: var(--primary-very-dark-color);\n    text-align: center;\n    font-family: \"Lexend Deca\";\n    font-size: 19px;\n    font-weight: var(--font-medium);\n    margin-top: 6px;\n}\n\n.no-pro-unlock-stat__message {\n    color: var(--primary-very-dark-color);\n    text-align: center;\n    font-family: \"Lexend Deca\";\n    font-size: 17px;\n    font-weight: var(--font-regular);\n    margin-top: 10px;\n}\n\n.no-pro-unlock-stats__advanteges {\n    margin-top: 18px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.no-pro-unlock-stat__advantage {\n    color: var(--primary-dark-color);\n    text-align: left;\n    font-family: \"Lexend Deca\";\n    font-size: 16px;\n    font-weight: var(--font-regular);\n    padding: 5px 0;\n}\n\n.no-pro-unlock-stat__advantage .hubicon-check1 {\n    font-size: 20px;\n    padding: 8px;\n}\n\n.no-pro-unlock-stat__bottom-message {\n    color: var(--basic-gray-color);\n    text-align: center;\n    font-family: \"Lexend Deca\";\n    font-size: 14px;\n    font-weight: var(--font-regular);\n    margin-top: 12px;\n}\n\n.no-pro-unlock-stats__container .button {\n    width: 100%;\n    text-transform: unset;\n}\n\n.no-pro-unlock-stats__container .button span {\n    text-transform: unset;\n}\n\n.no-pro-unlock-stats__container .button.primary-button {\n    margin-top: 24px;\n}\n\n.no-pro-unlock-stats__container .button.text-button {\n    margin-top: 10px;\n    color: var(--primary-very-dark-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
